// extracted by mini-css-extract-plugin
export default {"icon":"Social-icon_icon__BURDz","item":"Social-icon_item__cvs1+"};